var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolution1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96387 21.7496H47.2853M61.0353 21.7496H47.2853M47.2853 37.4639V21.7496M47.2853 9.96387V21.7496M61.0353 37.4639V57.1067C61.0353 58.1486 60.6214 59.1479 59.8846 59.8846C59.1479 60.6214 58.1486 61.0353 57.1067 61.0353H13.8924C12.8505 61.0353 11.8513 60.6214 11.1145 59.8846C10.3778 59.1479 9.96387 58.1486 9.96387 57.1067V13.8924C9.96387 12.8505 10.3778 11.8513 11.1145 11.1145C11.8513 10.3778 12.8505 9.96387 13.8924 9.96387H29.6067V37.4639H61.0353Z",
    stroke: "url(#paint0_linear_304_56)",
    strokeWidth: 4.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_56",
    x1: 9.96387,
    y1: 35.5006,
    x2: 61.0333,
    y2: 35.5006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0093FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution1);
export default __webpack_public_path__ + "static/media/solution1.68112b4b084afb89be8cfa77be3689ce.svg";
export { ForwardRef as ReactComponent };